"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mod = void 0;
const ctx_1 = require("../ctx");
const globals_1 = require("../globals");
const solution_1 = require("../solution");
class Mod {
    constructor(options) {
        this.options = options;
        this.initialized = false;
        this.solution = new solution_1.Solution();
        this.ctx = (0, ctx_1.CtxNull)();
        this.outputs = new Map();
        this.stmts = [];
        this.imported = [];
    }
    get env() {
        return (0, ctx_1.ctxToEnv)(this.ctx);
    }
    resolve(href) {
        return new URL(href, this.options.url);
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initialized)
                return;
            const globals = (0, globals_1.useGlobals)();
            yield globals.mount(this);
            this.initialized = true;
        });
    }
    executeStmts(stmts) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initialize();
            const outputs = [];
            const offset = this.stmts.length;
            for (const [index, stmt] of stmts.entries()) {
                const output = yield stmt.execute(this);
                this.stmts.push(stmt);
                (0, solution_1.solutionCleanup)(this.solution);
                if (output) {
                    this.outputs.set(offset + index, output);
                    outputs.push(output);
                }
            }
            return outputs;
        });
    }
    define(name, type, value) {
        this.ctx = (0, ctx_1.CtxFulfilled)(name, type, value, this.ctx);
    }
    delete(name) {
        this.ctx = (0, ctx_1.ctxDeleteFirst)(this.ctx, name);
    }
}
exports.Mod = Mod;
//# sourceMappingURL=Mod.js.map